<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div class="text-left" style="padding-top:0%" :style="viewStyle">
      <!-- Tabs -->
      <v-row class="ma-0 pt-2" style="padding-left: 20px; background:#FFF">
        <v-tabs color="#ED6D00" background-color="transparent">
          <v-tabs-slider color="#ED6D00"></v-tabs-slider>
          <v-tab>{{$t('__Organization')}}</v-tab>
        </v-tabs>
      </v-row>

      <div id="box" style="margin-top:3%">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
          <h4 class="primary-color" style="padding-top:2px">{{$t('__Organization')}}</h4>
        </v-row>
        
        <v-form ref="form" v-model="valid" lazy-validation :disabled="!canEdit">
          <v-row class="mx-2">
             <!-- Left Column -->
            <v-col class="pa-0 col-12 col-md-6">
              
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__groupName')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.groupName"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__vatNumber')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.vatNumber"></v-text-field>
                </v-col>
              </v-row>
              
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__orgNation')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.nation"></v-text-field>
                </v-col>
              </v-row>

            </v-col>

            <!-- Right Column -->
            <v-col class="pa-0 col-12 col-md-6">
              
              <v-row class="ma-0">
                 <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__address')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                   <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.address"></v-text-field>
                </v-col>
              </v-row>

               <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__tel')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                   <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.tel"></v-text-field>
                </v-col>
              </v-row>

               <v-row class="ma-0" v-if="datasets.createTime">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__createTime')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.createTime"></v-text-field>
                </v-col>
              </v-row>
               <v-row class="ma-0" v-if="datasets.updateTime">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__updateTime')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.updateTime"></v-text-field>
                </v-col>
              </v-row>

            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>
    
    <v-footer id="footer">
      <div class="text-center mx-auto footer">
        <v-btn class="btn" large color="#979491" style="color: #FFF; box-shadow:none" @click="redirectPath('/Configuration')">{{$t('__cancel')}}</v-btn>
        <v-btn v-if="canEdit" class="btn" large color="#ED6D00" style="color: #FFF; box-shadow:none" @click="saveDataset()">{{$t('__save')}}</v-btn>
      </div>
    </v-footer>
    <ShowMsg ref="ShowMsg" :onSave="onSaveSuccess" />
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ShowMsg from '@/dialogs/ShowMsg'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import { getEmployeeInfo } from '@/utils/auth'

export default {
  name: 'Organization',
  components: {ShowMsg, Loading},
  data: () => ({
    isLoading: false,
    valid: true,
    viewStyle: {},
    addNewData:0, //0-新增 1-修改
    datasets: {
      id: '',
      groupName: '',
      vatNumber: '',
      nation: '',
      address: '',
      tel: '',
      createTime: '',
      updateTime: ''
    },
    language: ''
  }),
  computed: {
    canEdit() {
      try {
        const info = getEmployeeInfo()
        if (info && info.function) {
          const perms = JSON.parse(info.function)
          const p = perms.find(e => e.key === 'Configuration')
          return p ? !!p.edit : false
        }
      } catch (e) {
        console.error('Failed to parse permissions:', e)
      }
      return false
    }
  },
  mounted() {
    this.language = i18n.locale
    this.addNewData = (this.$route.query.id == -1) ? 0 : 1
    this.checkMode()
  },
  created() {
    this.calculateWindows()
    this.$root.$on('windowInnerHeight', () => {
      this.calculateWindows()
    })
    this.$root.$on('language', (value) => {
      this.language = value
    })
  },
  methods: {
    calculateWindows() {
      this.viewStyle = {height: window.innerHeight - 135 + 'px'}
    },
    redirectPath(path) {
      this.$router.push({ path: path, query: { page: this.$route.query.page, tab: 0 } })
    },
    onSaveSuccess() {
      this.redirectPath('/Configuration')
    },
    checkMode() {
      if(this.addNewData != 0){
        this.getDataset(this.$route.query.id)
      } else {
        // Init empty or defaults
      }
    },
    getDataset(id) {
      this.isLoading = true
      var self = this
      var request = {
        method: 'GET',
        url: '/GetOrganization', 
        params: { id: id, lang: this.language || 'en-US' },
      }
      this.$http(request).then(function(response) {
        if (response.data.Data) {
            self.datasets = response.data.Data
        } else if (response.data.data) {
             self.datasets = response.data.data
        } else {
             self.datasets = response.data
        }
      }).catch((err) => {
        const errorMsg = err.response?.data?.Message || err.response?.data?.ErrorMessage || self.$t('__getDataError')
        self.$refs.ShowMsg.open(0, self.$t('__error'), errorMsg, true, true)
      }).finally(() => {
        self.isLoading = false
      })
    },
    saveDataset() {
      if (!this.$refs.form.validate()) return

      // Manual required field check
      if (!this.datasets.groupName) {
        this.$refs.ShowMsg.open(1)
        return
      }

      this.isLoading = true
      var self = this
      // Use CreateOrganization for new records, UpdateOrganization for existing
      var url = this.datasets.id ? '/UpdateOrganization' : '/CreateOrganization'
      var method = 'POST' 
      
      var request = {
        method: method,
        url: url,
        headers: {
          'Content-Type': 'application/json-patch+json'
        },
        data: this.datasets
      }
      this.$http(request).then(function(response) {
        if (response.data.State === '988' || response.data.State === '9882' || response.data.State === '9883') {
          self.$refs.ShowMsg.open(0, self.$t('__error'), self.$t('__groupNameExists'))
        } else {
          // Previously everything was treated as success. 
          // Treat non-9882 status as success to accommodate status codes like 103.
          self.$refs.ShowMsg.open(0, self.$t('__savedSuccessfully'), response.data.Message, true) 
        }
      }).catch((error) => {
        console.error('Save error:', error)
        var errorMsg = error.response?.data?.Message || self.$t('__saveFailed')
        self.$refs.ShowMsg.open(0, self.$t('__error'), errorMsg)
      }).finally(() => {
        self.isLoading = false
      })
    }
  }
}
</script>